import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

export type ScoutingCampaignHeaderLoadingProps = ExtendableStyles & Testable

export function ScoutingCampaignHeaderLoading({ className, style, ...otherProps }: ScoutingCampaignHeaderLoadingProps) {
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.container)} style={style} {...otherProps}>
      <div className={classes.userContent}>
        <Typography variant="h6">Loading Space data</Typography>
      </div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
  },
  avatar: {
    width: spacing(6),
    height: spacing(6),
  },
  userContent: {
    marginLeft: spacing(2),
    flex: '1 1 auto',
  },
}))
